import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "aspect-square w-14 bg-[#2F2F2F] rounded box-border flex items-center justify-center pr-1 hover:bg-gray-800" }

import {ArrowIcon} from "@/components/@icons"

export default /*#__PURE__*/_defineComponent({
  __name: 'ReturnButton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createVNode(_unref(ArrowIcon), { class: "w-3" })
  ]))
}
}

})